const filterObjectFalsy = (object) =>
    Object.keys(object).reduce((accumulator, key) => {
        if (object[key] || object[key] === 0) {
            accumulator[key] = object[key];
        }
        return accumulator;
    }, {});

export default filterObjectFalsy;
